

const initialMe = {
    "id": null,
    "name": "",
    "username": "",
    "subscription": null,
    "role": "",
    "entity": null,
    "user_team_id": null,
    "entity_logo_b64": null,
    "entity_stamp_b64": null,
    "access_level": null,
    "lastDocNumber": null,
    "call_refresh_user_data": null,
}


const MeReducer = (state=initialMe, action)=>{
    switch (action.type) {
        case 'UPDATE_USER_STATUS':
            return {
                ...state,
                ...action.data,
                //subscription: (action.data.entity && action.data.entity.subscriptions)?action.data.entity.subscriptions[0]:null
            }
        case 'UPDATE_USER_ACCESS_LEVEL':
            return {
                ...state,
                access_level:action.data
            }
        case 'SET_CURRENT_ENTITY':

            return {
                ...state,
                entity: action.data.currentEntity,
            }
        case 'UPDATE_STRUCTURE_INFO':
            return {
                ...state,
                entity: action.data,
            }
        case 'UPDATE_LAST_DOC_NUMBER':
            return {
                ...state,
                lastDocNumber: action.data
            }
        case 'SET_LOGO_B64':
            return {
                ...state,
                entity_logo_b64: action.data,
            }
        case 'SET_STAMP_B64':
            return {
                ...state,
                entity_stamp_b64: action.data,
            }
        case 'SET_USER_TEAM_ID':
        return {
            ...state,
            user_team_id: action.data
        }
        case 'SET_CALL_REFRESH_USER_DATA':
            return{
                ...state,
                call_refresh_user_data: action.data,
            }
        default:
            return state
    }
}


export default MeReducer
